import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import DashboardCard, { DashboardLink } from './DashboardCard';

const BADGE_TONES = {
  rose: 'bg-rose-50 text-rose-600 border-rose-200',
  teal: 'bg-teal-50 text-[#006666] border-teal-200',
  amber: 'bg-amber-50 text-amber-700 border-amber-200',
};

// documents: utils/ipoDashboard.js buildDashboardDocuments
export const IpoDocumentsCard = ({ board, documents, loading, error, onRetry, query = '' }) => (
  <DashboardCard
    title={`${board.shortLabel} IPO Documents & SEBI Filings`}
    subtitle="Latest Draft Red Herring (DRHP), Red Herring (RHP) and final prospectus filings"
    aside={<DashboardLink to={board.key === 'sme' ? '/drhp-filings?tab=sme' : '/drhp-filings'}>All Filings</DashboardLink>}
  >
    {loading ? (
      <ul className="grid grid-cols-1 sm:grid-cols-3 gap-3 px-4 sm:px-5 pb-4 sm:pb-5" aria-hidden="true">
        {Array.from({ length: 3 }).map((_, idx) => (
          <li key={idx} className="h-36 rounded-xl border border-slate-200 bg-slate-50 animate-pulse" />
        ))}
      </ul>
    ) : documents.length ? (
      <ul className="grid grid-cols-1 sm:grid-cols-3 gap-3 px-4 sm:px-5 pb-4 sm:pb-5">
        {documents.map((doc) => (
          <li key={doc.id} className="flex flex-col rounded-xl border border-slate-200 p-4 hover:border-slate-300 hover:shadow-sm transition-all">
            <div className="flex items-center justify-between gap-2">
              <span className={`px-2 py-0.5 rounded-md border text-[10px] font-bold uppercase tracking-wide ${BADGE_TONES[doc.tone]}`}>{doc.type}</span>
              <span className="text-[11px] text-slate-400 truncate">{doc.meta}</span>
            </div>
            <p className="mt-3 text-sm font-bold text-slate-900 leading-snug">{doc.title}</p>
            <p className="mt-0.5 text-[11px] text-slate-500 line-clamp-2">{doc.note}</p>
            <Link
              to={doc.to}
              className="mt-auto pt-3 self-start inline-flex items-center gap-1 text-xs font-bold text-[#008080] hover:text-[#006666] hover:underline"
            >
              {doc.action}
              <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </li>
        ))}
      </ul>
    ) : (
      <p className="mx-4 sm:mx-5 mb-4 sm:mb-5 rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center text-sm text-slate-500">
        {error ? (
          <>
            The filings registry is temporarily unavailable.{' '}
            <button type="button" onClick={onRetry} className="font-bold text-[#008080] hover:underline">
              Retry
            </button>
          </>
        ) : query.trim() ? (
          `No ${board.shortLabel} filing matches “${query.trim()}”.`
        ) : (
          `No ${board.shortLabel} filings in the DRHP tracker yet.`
        )}
      </p>
    )}
  </DashboardCard>
);

export default IpoDocumentsCard;
